/**
 * The three window size classes — docs/LAYOUT.md, "Three sizes, not seven
 * breakpoints". These are the ONLY layout breakpoints in the app; everything
 * else is a proportion.
 *
 *   compact   < 768   one column, bottom tab bar, detail is a pushed screen
 *   medium    768-1023  sidebar is an icon rail, detail slides over
 *   expanded  >= 1024  full sidebar with labels, detail sits beside content
 */
import { useMediaQuery } from './use-media-query.ts'

export const BREAKPOINTS = {
  medium: 768,
  expanded: 1024,
} as const

export type SizeClass = 'compact' | 'medium' | 'expanded'

export function useSizeClass(): SizeClass {
  const atLeastMedium = useMediaQuery(`(min-width: ${BREAKPOINTS.medium}px)`)
  const atLeastExpanded = useMediaQuery(`(min-width: ${BREAKPOINTS.expanded}px)`)
  if (atLeastExpanded) return 'expanded'
  if (atLeastMedium) return 'medium'
  return 'compact'
}
